
const onDocMouseover = (e) => {
  if (e.target.matches('.header-menu-primary > li > a:not(.show)')) {
    closeAllDropdowns();
  }
}

const onDropdownShow = (e) => {
  if (e.target.dataset.htmlClassName) {
    document.documentElement.classList.add(e.target.dataset.htmlClassName);
  }
}
const onDropdownHide = (e) => {
  if (e.target.dataset.htmlClassName) {
    document.documentElement.classList.remove(e.target.dataset.htmlClassName);
  }
}

export const closeAllDropdowns = () => {
  const list = [...document.querySelectorAll('.header-menu-primary a[data-bs-toggle].show')];
  list.forEach((el) => {
    el.click();
  })
  document.activeElement.blur();

}

export const initHeaderDropdown = () => {
  document.documentElement.addEventListener("mouseover", onDocMouseover);
  document.addEventListener("show.bs.dropdown", onDropdownShow);
  document.addEventListener("hide.bs.dropdown", onDropdownHide);
}